import { decode, encode } from "base-64";

export const getImage = (data) => {
  const imageElement = data.querySelector('image > url');
  if (imageElement) {
    return imageElement.textContent;
  }

  const itunesImage = data.querySelector('itunes\\:image, image');
  if (itunesImage) {
    return itunesImage.getAttribute('href');
  }
  
  return null;
};

export const isPodcastRssFeedValid = (rssFeed) => {
  const regex = new RegExp(
    /^(https?:\/\/)?((([a-z\d]([a-z\d-]*[a-z\d])*)\.)+[a-z]{2,}|((\d{1,3}\.){3}\d{1,3}))(:\d+)?(\/[-a-z\d%_.~+]*)*(\?[;&a-z\d%_.~+=-]*)?(\#[-a-z\d_]*)?$/i
  );
  return regex.test(rssFeed);
}

export const base64UrlEncode = (str) => {
    return encode(str)
        .replace(/\+/g, '-') // Replace + with -
        .replace(/\//g, '_') // Replace / with _
        //.replace(/=+$/, ''); // Remove trailing =
    };

export const base64UrlDecode = (str) => {
    str = str
        .replace(/-/g, '+') // Replace - with +
        .replace(/_/g, '/') // Replace _ with /
        //.padEnd(str.length + (str.length % 4), '='); // Pad with =

    return decode(str);
};

export const getPodcastKey = (encodedRssFeed, encodedMp3) => {
  return `${encodedRssFeed}#${encodedMp3}`;
}

export const extractPodcastMetadata = (note) => {
  const podcastMetadata = {
    pubDate: note.pubDate,
    description: note.description,
    title: note.title,
    mp3: note.mp3,
    uid: note.uid ? note.uid : "",
    image: note.image,
    rssFeed: note.rssFeed
  }
  return podcastMetadata;
}

export const mergeWithPodcastMetadata = (podcastMetadata, rssFeed, encodedRssFeed, encodedMp3) => {
  return {
    ...podcastMetadata,
    rssFeed: rssFeed,
    encodedRssFeed: encodedRssFeed,
    encodedMp3: encodedMp3,
  };
}

export const makePodcastObject = (encodedRssFeed, encodedMp3, bookmarks, podcastMetadata) => {
  const podcast = {
        encodedRssFeed,
        encodedMp3,
        bookmarks,
        podcastMetadata
    }
  return podcast;
}

export const buildPodcastFromHistory = (key, value) => {
  const podcast = {}
        podcast.id = key;
        podcast.title = value.title;
        podcast.image = value.image;
        podcast.updateTime = value.updateTime;
        podcast.pubDate = value.pubDate;
        podcast.description = value.description ? value.description : "";
        podcast.rssFeed = value.rssFeed;
        podcast.mp3 = value.mp3;
        podcast.uid = value.uid ? value.uid : "";
  return podcast;
}
